// ImportAssignmentModal.js
import React, {useState} from 'react';
import {gradeApi} from '../../../api.js';
import {useAuth} from '../../../auth/AuthContext';
import {ArrowLeft, Import} from 'lucide-react';

const ImportAssignmentModal = ({onClose, setErrorMessage, errorMessage, onImport}) => {
    const [code, setCode] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const {user} = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!code) {
            return;
        }
        
        setIsLoading(true);
        try {
            const response = await gradeApi.get({
                path: `/api/assignment/${code}/decode/`,
                config: {
                    headers: {
                        Authorization: `Bearer ${user.session_token}`
                    }
                }
            });

            const assignmentId = response.data.assignment_id;
            onImport(assignmentId);
        } catch (error) {
            setErrorMessage(error.response?.data?.error || 'Failed to decode assignment code');
            setIsLoading(false);
        }
    };

    return (
        <div className="w-full space-y-6">
            <button
                className="group flex items-center space-x-2 text-gray-500 hover:text-gray-900 transition-colors duration-200 mb-6"
                onClick={() => window.dispatchEvent(new CustomEvent('setCreateMode', { detail: true }))}
            >
                <ArrowLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform duration-200"/>
                <span>Back to Create Assignment</span>
            </button>
            
            <div className="flex items-center mb-6">
                <div className="flex justify-center items-center p-3 rounded-full bg-orange-50 mr-4">
                    <Import className="w-6 h-6 text-orange-500" strokeWidth={2} />
                </div>
                <div>
                    <h3 className="text-xl font-semibold text-gray-900">Import Shared Assignment</h3>
                    <p className="text-gray-500 mt-1">Enter the assignment code shared with you</p>
                </div>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
                <div className="flex flex-col">
                    <div className="relative">
                        <input
                            type="text"
                            value={code}
                            maxLength={8}
                            className={`w-full p-3 text-center text-xl font-mono tracking-wider rounded-lg border 
                                ${errorMessage ? 'border-red-300 focus:ring-red-200 focus:border-red-400' : 'border-gray-200 focus:ring-orange-100 focus:border-orange-300'} 
                                focus:ring-2 outline-none transition-all uppercase`}
                            placeholder="ENTER CODE"
                            onChange={(e) => {
                                setCode(e.target.value.toUpperCase());
                                if (errorMessage) {
                                    setErrorMessage('');
                                }
                            }}
                        />
                    </div>

                    {errorMessage && (
                        <div className="mt-2 text-sm text-red-600">
                            {errorMessage}
                        </div>
                    )}
                </div>

                <div className="pt-2">
                    <button
                        type="submit"
                        disabled={!code || isLoading}
                        className={`
                            w-full px-5 py-3 rounded-xl text-[0.875rem] font-medium transition-all duration-200 
                            ${!code || isLoading ? 
                                'bg-gray-100 text-gray-400 cursor-not-allowed' : 
                                'bg-gradient-to-br from-[#e4b17a] to-[#c99b69] text-white hover:from-[#c99b69] hover:to-[#b38a5e] hover:transform hover:-translate-y-0.5 shadow-sm hover:shadow'
                            }
                        `}
                    >
                        {isLoading ? 'Importing...' : 'Import Assignment'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default ImportAssignmentModal;